import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as DataTransfer } from '../../assets/images/svg/data-transfer.svg';
import themeColors from '../../assets/styles/themeColors';

const DataTransferStyled = styled(DataTransfer)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  fill: ${({ color }) => color || themeColors.colorBackgroundSecondaryLight};
  stroke: ${themeColors.colorTextPrimary};

  circle {
    stroke: none;
  }
`;

const DataTransferIcon = (props) => <DataTransferStyled {...props} />;

DataTransferIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

DataTransferIcon.defaultProps = {
  w: '40px',
  h: '40px',
};

export default DataTransferIcon;
